module.exports = __webpack_public_path__ + "static/orange-5082794705f514c36bb6d8dcb7cb3015.jpg";